import NumberInput from './NumberInput';


export default NumberInput;
export {
	NumberInput
};